import {
  IPartFinderAttribute,
  IPartFinderAttributeComparison,
  IPartFinderAttributePayload,
  IPartFinderAttributeVersion,
} from 'companySettings/types';
import { mapRecordsFromServer } from 'core/mappers';
import { partfinitiClient } from 'core/services';
import { GetManyResponse, IRequestPayload } from 'core/types';
import { getQueryStringToSnakeCase, objectKeysSnakeCaseToCamelCase } from 'core/utils';

export const getPartFinderAttributes = async (
  requestPayload?: IRequestPayload,
  signal?: AbortSignal
): Promise<GetManyResponse<IPartFinderAttribute>> => {
  const { data } = await partfinitiClient.get(
    `/part_v2/finder-attribute-list/list?${getQueryStringToSnakeCase(requestPayload)}`,
    signal
  );

  return mapRecordsFromServer<IPartFinderAttribute>(data?.data, data?.recordsFiltered);
};

export const savePartFinderAttribute = async (
  partFinderAttribute: IPartFinderAttributePayload
): Promise<{ success: boolean; partFinderAttribute: IPartFinderAttribute }> =>
  partfinitiClient.postForm('/part_v2/finder-attribute-edit/save', { partFinderAttribute });

export const removePartFinderAttributes = async (ids: number[]): Promise<{ success: boolean }> =>
  partfinitiClient.postForm('/part_v2/finder-attribute-edit/remove', { ids });

// Publishes the drafts of the lists; a list with no draft is left as it is.
export const publishPartFinderAttributes = async (
  ids: number[]
): Promise<{ success: boolean; published: number }> =>
  partfinitiClient.postForm('/part_v2/finder-attribute-edit/publish', { ids });

export const getPartFinderAttributeVersions = async (
  attributeId: number,
  signal?: AbortSignal
): Promise<IPartFinderAttributeVersion[]> => {
  const { data } = await partfinitiClient.get(
    `/part_v2/finder-attribute-version-list/list?${getQueryStringToSnakeCase({ attributeId })}`,
    signal
  );

  return objectKeysSnakeCaseToCamelCase(data?.versions ?? []);
};

export const comparePartFinderAttributeVersions = async (
  { fromVersionId, toVersionId }: { fromVersionId: number; toVersionId: number },
  signal?: AbortSignal
): Promise<IPartFinderAttributeComparison> => {
  const { data } = await partfinitiClient.get(
    `/part_v2/finder-attribute-version-list/compare?${getQueryStringToSnakeCase({
      from: fromVersionId,
      to: toVersionId,
    })}`,
    signal
  );

  return objectKeysSnakeCaseToCamelCase(data?.comparison);
};
